export const STATUS_COLORS = {
  0: 'transparent',
  1: '#FFFAE5', // Very Light Gold
  2: '#FFCBB2', // Very Light OrangeRed
  3: '#CFF3C8', // Very Light Green
  4: '#C7D6E9', // Very Light SteelBlue
  5: '#D1F2CF', // Very Light LimeGreen
  6: '#FFA3B5', // Very Light Crimson
};
